<template>
    <div class="map-icons">
        <HomeSearchControl
            ref="searchControlRef"
            :cadastral-blocked="cadastralBlocked"
            @select-search-item="handleSelect"
        />
    </div>

    <ModalsContainer :key="modalKey" />
</template>

<script setup>
import { ModalsContainer, useModal } from 'vue-final-modal'
import { defineAsyncComponent, onMounted, ref, watch, computed } from 'vue'
import HomeSearchControl from './HomeSearchControl.vue'

const bic = defineAsyncComponent(() => import('../../Components/MapActions/Bic/Bic.vue'))
const componentMap = { bic }

const props = defineProps({
    controls: Object,
    user: Object,
    cadastralBlocked: { type: Boolean, default: false },
})

const emits = defineEmits(['changeProperty', 'bicClosed', 'changeModal'])

const currentComponent = computed(() => componentMap[props?.controls?.menu?.action?.name] || null)
const currentId = computed(() => props.controls?.menu?.action?.attrs?.propertyId)
const searchSelect = computed(() => props.controls?.menu?.action?.attrs?.searchSelect)
const subdivisionPropertyId = computed(() => props.controls?.menu?.action?.attrs?.subdivisionPropertyId)
const bicSelectionKey = computed(() => props.controls?.menu?.action?.attrs?.bicSelectionKey ?? 0)
const isModalOpen = ref(false)
const modalKey = ref(0)

const remountBicModal = () => {
    if (props.cadastralBlocked || !currentId.value) {
        isModalOpen.value = false
        return
    }
    isModalOpen.value = true
    modalKey.value++
    open()
}

const { open } = useModal({
    component: defineAsyncComponent(() => import('../../Components/ModalDragResize.vue')),
    attrs: {
        key: modalKey,
        component: currentComponent,
        componentProps: {
            registration: currentId,
            subdivisionPropertyId: subdivisionPropertyId,
            searchSelect: searchSelect,
            onSelectProperty: (e) => {
                emits('changeProperty', {
                    propertyId: e,
                    searchSelect: true
                })
            }
        },
        h: window.innerHeight - 0,
        w: 930,
        x: 0,
        y: 0,
        onClosed: () => {
            isModalOpen.value = false
            if (currentComponent.value) {
                emits('bicClosed')
            }
        }
    }
})

watch(
    () => [currentId.value, bicSelectionKey.value],
    ([id, key], [prevId, prevKey]) => {
        if (props.cadastralBlocked) {
            return
        }
        if (!id) {
            isModalOpen.value = false
            return
        }
        if (id === prevId && key === prevKey) {
            return
        }
        remountBicModal()
    }
)

const handleSelect = (item) => {
    if (props.cadastralBlocked) {
        return
    }
    const payload = {
        searchSelect: true,
        searchType: item.searchType
    }
    if (item.propertyId) payload.propertyId = item.propertyId
    if (item.streetId) payload.streetId = item.streetId
    emits('changeProperty', payload)
}

onMounted(() => {
    if (props.cadastralBlocked || !currentId.value) {
        return
    }
    remountBicModal()
})

watch(isModalOpen, (newVal) => emits('changeModal', newVal))
</script>

<style scoped>
.map-icons {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
}

.map-icon-btn {
    width: var(--home-map-icon-size, 32px);
    height: var(--home-map-icon-size, 32px);
    border-radius: var(--home-map-icon-radius, 6px);
    background-color: rgba(0, 60, 136, 0.6);
    color: white;
    border: 2px solid white;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.map-icon-btn:hover {
    background-color: rgba(0, 60, 136, 0.7);
}

.menu-icon {
    color: white;
    font-size: var(--home-map-icon-glyph-size, 16px);
}
</style>
